import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './ActionButton.css'

class ActionButton extends Component {
    static defaultProps = {};

    static propTypes = {};

    state = {};
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.action('yo')
    }

    render() {
        return (
            <button
                className="ActionButton"
                onClick={this.handleClick}
            >
                {this.props.label}
            </button>
        );
    }
}

export default ActionButton;



// WEBPACK FOOTER //
// ./src/components/ActionButton/ActionButton.js